// import React from 'react';
import styled from 'styled-components';
import backgroundImage from './../Assets/webback.png.png' // Assuming webback.png is the correct filename and path
import contaninerImage from '../Assets/About US.png'
import contanier2Image from './../Assets/Our Mission Pic.png'
import contanier3Image from './../Assets/Group 67.png'
import { TiTick } from "react-icons/ti";
import contanier4Image from './../Assets/Our Vision (1).png'
// import contanier5Image5 from '../assets/Group29.png'
import contanier6Image6 from './../Assets/Loveforclient.jpg'
import mobileappimage from './../Assets/AboutUs1.jpg'
import { useState } from 'react';
import React, { useEffect } from 'react';
// import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const PageContainer0 = styled.div`
  box-sizing: border-box;
  width:100%;
  height: 100%;
 
 `

const ContentWrapper = styled.div`
  text-align: center;
  /* background-color: red; */
`;
const Contanier1 = styled.div`
width: 100%;
height: 700px;
display: flex;
justify-content: center;
align-items: center;
/* background-color: red; */
box-sizing:border-box;
gap: 40px;
@media screen and (max-width:600px){
max-width: 100%;
height: auto;
flex-direction: column;
gap: 10px;
 }
 @media screen and (max-width:600px) {


flex-direction: column-reverse;

 }
 @media screen and (min-width:601px) and (max-width:1024px) {
max-width: 100%;
height: auto;

flex-direction: column;
gap: 10px;
 }
 @media screen and (min-width:601px) and (max-width:1024px) {


flex-direction: column-reverse;

 }
 @media screen and (min-width:1441px) and (max-width:2200px) {

  max-width: 100%;
height: auto;
padding-left: 150px;
padding-right: 150px;
 }

`
const ContanierImage1 = styled.img`
width: 50%;
height: 654px;
margin-left: 40px;
margin-top: 30px;
@media screen and (max-width:600px){
  width: 100%;
max-width: 95%;
height:auto;
/* height: 380px; */
overflow: hidden;
margin-left: 0px;

 }
 @media screen and (min-width:601px) and (max-width:1024px){
  width: 100%;
max-width: 95%;
height:auto;
/* height: 380px; */
overflow: hidden;
margin-left: 0px;

 }
 @media screen and (min-width:1025px) and (max-width:1440px) {
  width: 40%;
  height:auto;
 }
 @media screen and (min-width:1441px) and (max-width:2200px) {

}

`

const ContanierAbout = styled.div`
width: 50%;
height: 654px;
box-sizing: border-box;
/* background-color: yellow; */
margin-right: 30px;
/* justify-content: left; */
/* align-items: flex-start;   */
margin-top: 30px;
@media screen and (max-width:600px){

width: 100%;
max-width:95%;
height: auto;
margin-top:0px;
margin: 10px;
margin-right: 20px;
margin-left: 20px;
 }
 @media screen and (min-width:601px) and (max-width:1024px){

width: 100%;
max-width:90%;
height: auto;
margin-top:0px;
margin: 10px;
margin-right: 20px;
margin-left: 20px;
 }
 @media screen and (min-width:1441px) and (max-width:2200px){

width: 100%;
max-width:55%;
height: auto;
margin-top:0px;
margin: 10px;
margin-right: 20px;
margin-left: 20px;
 }
`
const AboutHead = styled.h1`
margin-top: 20px;
text-align: left;
color: darkblue;
  font-size: 3rem;
  margin-bottom: 1rem;

  @media screen and (max-width:600px){
text-align: center;
align-items: center;
justify-content: center;
font-size: 26px;

 }
 @media screen and (min-width:601px) and (max-width:1024px){
  text-align: center;
align-items: center;
justify-content: center;
font-size: 30px;
 }
 @media screen and (min-width:1441px) and (max-width:2200px){

font-size: 4rem;
 }
`
const AboutPara = styled.p`
  text-align: left;
  font-size: 1.2rem;
  @media screen and (max-width:600px){
text-align: center;
align-items: center;
justify-content: center;
font-size: 14px;
 }
 @media screen and (min-width:601px) and (max-width:1024px){
  text-align: center;
align-items: center;
justify-content: center;
font-size: 16px;
 }
 @media screen and (min-width:1025px) and (max-width:1440px){


line-height: 40px;
 }
 @media screen and (min-width:1441px) and (max-width:2200px){

font-size: 1.4rem;
line-height: 30px;
 }
`
const Div = styled.div`
width: 100%px;
height:300px;
margin-top: 30px;
/* background-color: red; */
margin-left: 70px;
text-align:left;
font-size:1.3rem;
@media screen and (max-width:600px){
margin-left: 0%;
margin-top: 0%;
 }
`

const Contanier2 = styled.div`
width: 100%;
height: 700px;
display: flex;
align-items: center;
text-align: center;
justify-content: center;
box-sizing: border-box;
gap: 40px;
/* background-color: purple; */
@media screen and (max-width:600px){
  width: 100%;
max-width: 96%;
height: auto;
margin: 10px;
flex-direction: column;
 }
 @media screen and (min-width:601px) and (max-width:1024px){
  width: 100%;
max-width: 96%;
height: auto;
margin: 10px;
flex-direction: column;
 }
 @media screen and (min-width:1441px) and (max-width:2200px){
  padding-left:150px;
  padding-right: 150px;
 }
`

const Contanier2Image1 = styled.img`
width: 50%;
height: 654px;
margin-top: 30px;
margin-right: 30px;
@media screen and (max-width:600px){
  width: 100%;
max-width: 95%;
align-items: center;
justify-content: center;
text-align: center;
height: auto;
margin-left: 0%;
margin-right: 0%;
margin-top: 0%;
flex-direction: column;
 }
 @media screen and (min-width:601px) and (max-width:1024px) {
  width: 100%;
max-width: 95%;
align-items: center;
justify-content: center;
text-align: center;
height: auto;
margin-left: 0%;
margin-right: 0%;
margin-top: 0%;
flex-direction: column;
 }
 @media screen and (min-width:1025px) and (max-width:1440px) {
  width: 40%;
  height:auto;
 }
`
const ContanierMission = styled.div`
  width: 100%;
height: 654px;
/* background-color: yellow; */
/* justify-content: left; */
/* align-items: flex-start;   */
margin-top: 30px;
margin-left: 40px;
box-sizing: border-box;
@media screen and (max-width:600px){
max-width: 100%;
margin-left: 0%;
height: auto;
align-items: center;
text-align: center;
flex-direction: column;
 }
 @media screen and (min-width:601px) and (max-width:1024px){
  width:100%;
max-width: 90%;
margin-left: 20px;
height: auto;
align-items: center;
text-align: center;
flex-direction: column;
 }
 @media screen and (min-width:1025px) and (max-width:1440px) {
  width: 50%;
  height: auto;
  
 }
`
const Contanier3 = styled.div`
width: 100%;
height: 700px;
display: flex;
align-items: center;
text-align: center;
justify-content: center;
box-sizing: border-box;
gap: 40px;
/* background-color: #f121f1; */
@media screen and (max-width:600px){
max-width: 100%;
height: auto;
flex-direction: column;
 }
 @media screen and (max-width:600px) {

flex-direction: column-reverse;

 }
 @media screen and (min-width:601px) and (max-width:1024px) {
max-width: 100%;
height: auto;
flex-direction: column;

 }
 @media screen and (min-width:601px) and (max-width:1024px) {

flex-direction: column-reverse;

 }
 @media screen and (min-width:1441px) and (max-width:2200px){
  padding-left:150px;
  padding-right: 150px;
 }
`
const OurCoreValue = styled.p`
  text-align: left;
  font-size: 1.2rem;
  margin-top: 10px;
  @media screen and (max-width:600px){
text-align: center;
align-items: center;
justify-content: center;
font-size: 14px;
 }
 @media screen and (min-width:601px) and (max-width:1024px){
text-align: center;
align-items: center;
justify-content: center;
font-size: 16px;
 }
`
const OurValues = styled.h4`

`
const StyledTickIcon = styled(TiTick)`
  background-color: black;
  color: white;
  margin-right: 15px;
  padding: 5px; /* Optional: adjust padding as needed */
  border-radius: 50%; /* Optional: makes the background circular */
`;
const Contanier4 = styled.div`
width: 100%;
height: 700px;
display: flex;

gap: 40px;
@media screen and (max-width:600px){
  width: 100%;
max-width: 95%;
height: auto;
margin:10px;
text-align: center;
justify-content: center;
align-items: center;
flex-direction: column;
 }
 @media screen and (min-width:601px) and (max-width:1024px) {
  width: 100%;
max-width: 95%;
height: auto;
margin:10px;
text-align: center;
justify-content: center;
align-items: center;
flex-direction: column;
 }
 @media screen and (min-width:1441px) and (max-width:2200px){
  padding-left:150px;
  padding-right: 150px;
 }
`
const ContanierImage4 = styled.img`
  width: 50%px;
height: 654px;
margin-right: 30px;
margin-top: 30px;
box-shadow: 8px 8px 10px 8px rgba(0, 0, 0, 0.3);
border-radius: 3%;
@media screen and (max-width:600px){
  width:100%;
max-width: 95%;
height: auto;
flex-direction: column;
margin-left: 0%;
margin:10px;
 }
 @media screen and (min-width:601px) and (max-width:1024px) {
  width:100%;
max-width: 95%;
height: auto;
flex-direction: column;
margin-left: 0%;
margin:10px;
 }
 @media screen and (min-width:1025px) and (max-width:1440px) {
  margin-top: 10%;
  width: 40%;
  height:70%;
 }
`
const Contanier4Image2 = styled.img`
width: 550px;
height: 400px;

`
const Div5 = styled.div`
  width: 100%;
height:400px;
margin-top: 30px;
/* background-color: red; */
/* margin-left: 40px; */
text-align:left;
font-size:1.3rem;
`
const Contanier6 = styled.div`
width: 100%;
height: 638px;
align-items: center;
justify-content: center;
text-align: center;
/* background-color: pink; */
@media screen and (max-width:600px){
  width:100%;
max-width: 95%;
height: auto;
flex-direction: column;
margin-left: 0%;
margin:10px;
 }
 @media screen and (min-width:601px) and (max-width:1024px) {
  width:100%;
max-width: 97%;
height: auto;
flex-direction: column;
margin-left: 0%;
margin:10px;
 }
 @media screen and (min-width:1441px) and (max-width:2200px) {
  width:100%;
max-width: 99%;
height: auto;
flex-direction: column;
margin-left: 0%;
margin:10px;
 }
 @media screen and (min-width:1025px) and (max-width:1440px) {
  width:100%;
max-width: 99%;
height: auto;
flex-direction: column;
margin-left: 0%;
margin:10px;
 }
`
const AboutHead6 = styled.h1`
  margin-top: 20px;
  text-align: center;
color: darkblue;
justify-content: center;
align-items: center;
font-size: 3rem;
  margin-bottom: 1rem;
  /* margin-left:100px; */
  @media screen and (max-width:600px){
  font-size: 2rem;
margin:10px;
 }
 
 @media screen and (max-width:1025px) and (max-width:1440px) {
  font-size: 2rem;

 }
`
const ContanierImage6 = styled.img`
  width: 100%;
  height:591;

  @media screen and (max-width:600px){
  width:100%;
max-width: 95%;
height: auto;
flex-direction: column;
margin-left: 0%;
margin:10px;
 }
 @media screen and (min-width:601px) and (max-width:1024px) {
  width:100%;
max-width: 95%;
height: auto;
flex-direction: column;
margin-left: 0%;
margin:10px;
 }
 

`

const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
  /* background-color: green; */
  margin-left: 40px;
  margin-top: 30px;
  text-align: left;
`;

const Paragraph = styled.p`
font-size:1.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: ${props => (props.expanded ? 'normal' : 'nowrap')};
  max-height: ${props => (props.expanded ? 'none' : '3.6em')}; // Adjust based on line height
  @media screen and (max-width:600px) {
    font-size:14px;
  }
  @media screen and (min-width:601px) and (max-width:1024px){
  
font-size: 16px;
 }
 @media screen and (min-width:1025px) and (max-width:1440px){

/* font-size: 1.4rem; */
line-height: 40px;
 }

  @media screen and (min-width:1441px) and (max-width:2200px){

font-size: 1.4rem;
line-height: 30px;
 }
`;

const Button = styled.button`
  border: none;
background-color: blue;
cursor: pointer;
color: white;
padding: 10px;
padding-left: 15px;
padding-right:15px;
margin-left: 10px;
margin-top: 10px;
border: none;
border-radius: 5px;
`;
const Container8 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 100vh; */
  /* background-color: #0ef3e0; */
  /* margin-left: 10px; */
  
  /* border-radius: 25px; */
  /* box-shadow: 0 4px 4px 4px rgba(0.2, 0.2, 0.2, 0.2); // Black shadow */
`;
const ProgressBarContainer = styled.div`
  width: 100%;
  height: 430px;
  box-sizing: border-box;
  /* background-color: #d81c1c; */
  /* border-radius: 25px; */
  padding: 10px;
  /* margin-top: 5px; */
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
  overflow: hidden;
`;
const ProgressBar = styled.div`
  margin: 20px 0;

`;
const ProgressBarLabel = styled.div`
  font-size: 1em;
  margin-bottom: 6px;
  font-weight: bold;
  @media screen and (max-width:600px) {
    font-size: 15px;
  }
  @media screen and (min-width:601px) and (max-width:1024px) {
    font-size: 16px;
  }
`;
const ProgressBarFiller = styled.div`
  height: 15px;
  background-color: #959697;
  width: ${({ width }) => width};
  transition: width 0.5s ease-in-out;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  box-sizing: border-box;
`;
const Wrap = styled.div`
width: 100%;
height: 100%;
  padding: 0%;
  margin: 0%;
  box-sizing: border-box;
  /* background-color: #05f705; */
`
const PercentageLabel = styled.span`
  color: #000000;
  font-weight: bold;
  margin-bottom: 35px;
  font-size: 16px;
   /* Adjusts space below the percentage */
 
`;
const MobileAppImage = styled.img`
position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  object-fit: cover;
  z-index: -1;
@media (max-width:600px){
  width:100%;
  height:auto;
}
@media (min-width:601px) and (max-width:1024px){
  width:100%;
  height:autopx;
}
`

const AboutUs = () => {

  useEffect(() => {
    AOS.init();
  }, []);

  const skills = [
    { label: 'PRODUCT OPTIMIZATION', width: '90%' },
    { label: 'PPC MANAGEMENT', width: '85%' },
    { label: 'INVENTERY MANAGMENT', width: '70%' },
    { label: 'AMAZON SEO', width: '90%' },
    { label: 'BRAND PROTECTION', width: '80%' },
    { label: 'AR/VR', width: '50%' },
  ];

  const [expanded, setExpanded] = useState(false);

  const toggleReadMore = () => {
    setExpanded(!expanded);
  };

  const [expanded1, setExpanded1] = useState(false);

  const toggleReadMore1 = () => {
    setExpanded1(!expanded1);
  };


  return (
    <>
    <Wrap>
      
      <ContentWrapper>
      <MobileAppImage src={mobileappimage} alt='Background' />
        <Contanier1>
          <ContanierImage1 src={contaninerImage} alt='Backgrond' />

          <ContanierAbout>
            <AboutHead data-aos="fade-right">About Us</AboutHead>
            <AboutPara data-aos="fade-right">We Shape the perfect Solution for ZoFinds takes pride in delivering high-end services to you. We belive that amazing projects start with amazing
              people. So, we have put togather a team of wildly creative designers and developers who are not only the best of the best in thier jobs but also very love every second of it.</AboutPara>
            <Container>
              <Paragraph expanded={expanded}>
                <b>Bring us your idea and we will turn it into a reality that is perfect for you</b> <br ></br>We Shape the Perfect Solution for Umer Bazar takes pride in delivering
                high-end services to you. We belive that amazing projects start with amazing people.<br></br>
              </Paragraph>
              <Button data-aos="fade-right" onClick={toggleReadMore}>
                {expanded ? 'Read Less' : 'Read More'}
              </Button>
            </Container>
          </ContanierAbout>
        </Contanier1>
        <Contanier2>
          <ContanierMission>
            <AboutHead data-aos="fade-right">OUR MISSION</AboutHead>
            <AboutPara data-aos="fade-right">We Shape the perfect Solution for ZoFinds takes pride in delivering high-end services to you. We belive that amazing projects start with amazing
              people. So, we have put togather a team of wildly creative designers and developers who are not only the best of the best in thier jobs but also very love every second of it.</AboutPara>
            <Container>
              <Paragraph expanded={expanded1}>
                <b>Bring us your idea and we will turn it into a reality that is perfect for you</b> <br></br>We Shape the Perfect Solution for ZoFinds takes pride in delivering
                high-end services to you. We belive that amazing projects start with amazing people.<br></br>
              </Paragraph>
              <Button data-aos="fade-right" onClick={toggleReadMore1}>
                {expanded1 ? 'Read Less' : 'Read More'}
              </Button>
            </Container>
          </ContanierMission>
          <Contanier2Image1 src={contanier2Image} alt='Backgrond' />

        </Contanier2>
       
        <Contanier4>


          <ContanierMission>
            <AboutHead data-aos="fade-right">OUR VISION</AboutHead>
            <AboutPara ><b>Scaling up while maintaining efficiency </b> <br></br></AboutPara>
            <OurCoreValue data-aos="fade-right">We revolutionize the way people access and use technology, by providing cutting-edge, use-friendly and accessible solutions that meet the deverse needs.</OurCoreValue>
            <Div5>
              <Container8>
                <ProgressBarContainer>
                  {skills.map((skill, index) => (
                    <ProgressBar key={index} data-aos="fade-right">
                      <ProgressBarLabel>{skill.label}</ProgressBarLabel>
                      <ProgressBarFiller width={skill.width}>
                      <PercentageLabel>{skill.width}</PercentageLabel>
                      </ProgressBarFiller>
                    </ProgressBar>
                  ))}
                </ProgressBarContainer>
              </Container8>
            </Div5>
          </ContanierMission>
          <ContanierImage4 src={contanier4Image} alt='Backgrond' />
        </Contanier4>
        <Contanier6>



          <AboutHead6 data-aos="fade-right">LOVE FOR CLIENT</AboutHead6>
          <ContanierImage6 src={contanier6Image6} alt='Backgrond' />

        </Contanier6>

      </ContentWrapper>
      </Wrap>
    </>
  );
};

export default AboutUs;
